import set_or_update_queryparam from "../../custom_js/set_or_update_queryparam.js";
import getQueryParam from "../../custom_js/get_query_param.js";
import refineSorters from "./refine_sorters.js";
import { funnel } from "../../custom_js/get_svg_sort.js";
import { pyramid } from "../../custom_js/get_svg_sort.js";

up.compiler(".up_sortby_price", function (element) {
  async function onClick() {
    // change link
    const old_link = element.getAttribute("href");
    const old_order = getQueryParam("order", old_link);
    const new_order = old_order === "desc" ? "asc" : "desc";
    let new_link = set_or_update_queryparam(old_link, "order", new_order);
    new_link = set_or_update_queryparam(new_link, "sortby", "price");
    element.setAttribute("href", new_link);

    // change SVG direction
    if (new_order === "asc") {
      element.querySelector(".js-sorter").innerHTML = pyramid;
    } else {
      element.querySelector(".js-sorter").innerHTML = funnel;
    }

    // propagate new param value
    refineSorters("price", new_order);

    // go to required link
    await up.navigate({
      url: new_link,
      target: ".tbody, .js-workshop-detail, .js-selection",
    });
  }
  element.addEventListener("click", onClick);
  return () => {
    element.removeEventListener("click", onClick);
  };
});
